import $ from "jquery";
import "./shareAr.scss";

export function shareArComponent(container) {
  const html = $(`
    <div class="share-ar__container" id="share">
      <div class="share-ar__container-share" >
        <h3 class="share-ar__container-share__title">Share Configurator</h3>

        <div class="share-ar__container-share__close" id="share-close"></div>

         <div class="share-ar__container-share__bottom">
           <input class="share-ar__container-share__bottom__link" id="input" type="text">

           <button class="share-ar__container-share__bottom__button" id="copy"></button>
         </div>
      </div>
    </div>`);
  const htmlAR = $(
    `
    <div class="ar__container" id="ar">
        <div class="ar">

        <h3 class="ar__title">Scan the QR code with your phone. Within 1-3 seconds the AR function opens on your phone.</h3>

        <div class="ar__close" id="ar-close"></div>
        
         <div class="ar__bottom" id="qr-container">

         </div>
        </div>
    </div>
    `
  );

  const copyButton = html.find("#copy");
  const closeButton = html.find("#share-close");
  const closeButtonAR = htmlAR.find("#ar-close");

  const input = html.find("#input");
  input.val(window.location.href);

  copyButton.on("click", function (e) {
    e.preventDefault();

    const inputElement = $("#share").find('input[type="text"]').first();
    if (inputElement.length) {
      const url = inputElement.val();
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(() => {
        }).catch(err => {
          console.error('failed to copy URL', err);
          fallbackCopy(inputElement[0]);
        });
      } else {
        // Fallback for older browsers
        fallbackCopy(inputElement[0]);
      }
    }
  });

  function fallbackCopy(inputElement) {
    inputElement.select();
    try {
      document.execCommand('copy');
    } catch (err) {
      console.error('Fallback copy failed:', err);
    }
  }

  closeButton.on("click", () => {
    html.hide();
  });

  closeButtonAR.on("click", () => {
    htmlAR.hide();
    console.log("click");
  });

  html.hide();
  htmlAR.hide();

  $(container).append(html);
  $(container).append(htmlAR);
}
